import { useEffect, useState, useCallback, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, NODE_SERVER_URL } from "../utils/crudFunctions";
import { getToken, getUserRole } from "../utils/auth";
import { useDropzone } from "react-dropzone";
import {
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiSave,
  FiX,
  FiImage,
  FiTag,
  FiUpload,
  FiDownload,
  FiScissors,
  FiChevronDown,
  FiBarChart2,
  FiUserPlus,
  FiCalendar,
  FiUser,
  FiRefreshCw,
  FiCheckCircle,
  FiXCircle,
  FiPercent,

} from "react-icons/fi";

import {
  // saveClasses,
  // getImages,
  // addMoreImages,
  // getProjectName,
  // // saveAnnotations,
  // getDBUserName,
} from "../utils/ImageDB";
import {
  saveProjectClasses,
  getProjectClasses,
  addImages,
  getProjectAnnotations,
  getProjectSegmentAnnotation,
  getProjectOcrAnnotations,
  getProjectThumbnails,
  getProjectStats,
  setAnnotationType,
} from "../utils/crudFunctions";
import { uploadModel } from "../utils/inferenceUtils";


import AnnotaionHeatmap from "../components/AnnotaionHeatmap";
import ImageSection from "../components/ImageSection";
import { CLASS_COLORS } from "../utils/classColors";
import streamSaver from "streamsaver"

function ProjectOverview({ setProjectName }) {
  const { projectName } = useParams();
  const { userName } = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newClassName, setNewClassName] = useState("");
  const [editingClass, setEditingClass] = useState(null);
  const [editClassValue, setEditClassValue] = useState("");
  const [uploading, setUploading] = useState(false);
  const [allAnnotations, setAllAnnotations] = useState([]);
  const [downloadProgress, setDownloadProgress] = useState("0%");
  const [labelOrSegment, setLabelOrSegment] = useState(null);
  const [loadingType, setLoadingType] = useState(false);
  const [datasetLength, setDatasetLength] = useState(() => {
    const savedLength = localStorage.getItem(`${projectName}_datasetLength`);
    return savedLength ? parseInt(savedLength) : 0;
  });

  const [showStatsDropdown, setShowStatsDropdown] = useState(false);
  const [stats, setStats] = useState(null);

  // for image assignment
  const [showAssignMenu, setShowAssignMenu] = useState(false);
  const [users, setUsers] = useState([]);
  const [token, setToken] = useState("");


  // Get token and fetch users when component mounts
  useEffect(() => {
    const token = getToken();

    if (!token) {
      navigate("/login");
    }
    setToken(token);
  }, [navigate]);

  const fetchUsers = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get_users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("users", response.data.users);
      setUsers(response.data.users);
    } catch (err) {
      console.error("Failed to fetch users", err);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchUsers();
    }
  }, [token, fetchUsers]);



  const assignImages = async (targetUser, imageCount) => {
    try {
      await axios.post(
        `${API_BASE_URL}/assign_project`,
        { projectName, targetUser, imageCount },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(`Assigned ${imageCount} images to ${targetUser}`);
      // Refresh stats after assignment
      const stats = await getProjectStats(projectName);
      setStats(stats);
    } catch (err) {
      console.error("Assignment failed", err);
      alert(err.response?.data?.message || "Failed to assign images.");
    }
  };

  const fetchAnnotationType = useCallback(async () => {
    try {
      setLoadingType(true);
      const stats = await getProjectStats(projectName);
      setStats({
        annotationType: stats.project_info.annotation_type,
        createdAt: stats.project_info.created_at,
        createdBy: stats.project_info.created_by,
        updatedAt: stats.project_info.updated_at,
        totalImages: stats.image_stats.total_images,
        labeledImages: stats.image_stats.labeled_images,
        unlabeledImages: stats.image_stats.unlabeled_images,
        completionPercentage: stats.image_stats.completion_percentage,
      });
      return { type: stats.project_info.annotation_type };
    } catch (error) {
      console.error("Failed to load annotation type:", error);
    } finally {
      setLoadingType(false);
    }
  }, [projectName]);

  // useEffect(() => {
  //   fetchAnnotationType();
  // }, [fetchAnnotationType]);


  const handleTypeChange = async (type) => {
    try {
      setLoadingType(true);
      const success = await setAnnotationType(projectName, type);
      if (success) {
        setLabelOrSegment(type);
      }
    } catch (error) {
      console.error("Failed to update annotation type:", error);
    } finally {
      setLoadingType(false);
    }
  };

  // ------------------------project type end----------------------------
  const loadClasses = useCallback(async (useBackendData) => {
    try {
      // console.log("backendClasses");
      const backendClasses = await getProjectClasses(projectName);

      // await saveClasses(backendClasses); // Save to IndexedDB for future use

      return backendClasses;

      // console.log("localClasses");
      // return await getClasses(); // From IndexedDB
    } catch (error) {
      console.error("Failed to load classes:", error);
      return [];
    }
  }, [projectName])

  const loadImages = useCallback(async (useBackendData) => {
    try {
      if (useBackendData) {
        // let startIndex = 0;
        // let endIndex = 10;
        // let isInitialLoad = true;
        const result = await getProjectThumbnails(
          projectName


        );
        if (result.datasetLength) {
          setDatasetLength(result.datasetLength);
          localStorage.setItem(
            `${projectName}_datasetLength`,
            result.datasetLength.toString()
          );
        }
        return result.images || [];
      }

      // For local loading, implement pagination
      // console.log("local images");
      // return await getImages();
    } catch (error) {
      console.error("Failed to load images:", error);
      return [];
    }
  }, [projectName])

  // going to use annotations from backend only
  const loadAnnotations = useCallback(async (useBackendData, type) => {
    try {
      if (!type) return [];
      // console.log("backendAnnotations");
      let backendAnnotations = [];
      if (type === "label") {
        backendAnnotations = await getProjectAnnotations(projectName);
      } else if (type === "segment") {
        backendAnnotations = await getProjectSegmentAnnotation(projectName);
      }
      else if (type === "ocr") {
        backendAnnotations = await getProjectOcrAnnotations(projectName);
      }


      console.log("backendAnnotations", backendAnnotations);
      // await saveAnnotations(backendAnnotations);

      return backendAnnotations;


    } catch (error) {
      console.error("Failed to load annotations:", error);
      return [];
    }
  }, [projectName])

  const initializeProject = useCallback(async () => {
    let isMounted = true;
    console.log("Initializing project:", projectName);

    try {
      setLoading(true);
      setProjectName(projectName);
      const { type } = await fetchAnnotationType(projectName);
      setLabelOrSegment(type);

      const [loadedClasses, loadedImages, loadedAnnotations] = await Promise.all([
        loadClasses(true),
        loadImages(true),
        loadAnnotations(true, type),
      ]);

      if (isMounted) {
        setClasses(loadedClasses);
        setImages(loadedImages);
        setAllAnnotations(loadedAnnotations);
      }
    } catch (error) {
      console.error("Initialization failed:", error);
    } finally {
      if (isMounted) setLoading(false);
    }
  }, [projectName, loadClasses, loadImages, loadAnnotations]);

  useEffect(() => {
    initializeProject();
  }, [initializeProject, userName]);




  // using backend classes only

  // revoke object URLs when they're no longer needed: CLEANUP
  useEffect(() => {
    return () => {
      images.forEach((image) => {
        URL.revokeObjectURL(image.data);
      });
    };
  }, [images]);

  // initialization and loading data --------------------

  // class manangement --------------------------------
  const handleAddClass = async () => {
    const names = newClassName.trim();
    if (!names) return;

    // Split by comma and trim each name
    const classNames = names
      .split(",")
      .map((name) => name.trim())
      .filter((name) => name);

    if (classNames.length === 0) return;

    // Check for duplicates
    const duplicates = classNames.filter((name) =>
      classes.some((cls) => cls.name === name)
    );

    if (duplicates.length > 0) {
      console.error(
        `Class names must be unique. Duplicates found: ${duplicates.join(", ")}`
      );
      return;
    }

    try {
      const newClasses = [...classes];
      const startIndex = classes.length;

      // Add each new class
      for (let i = 0; i < classNames.length; i++) {
        const name = classNames[i];
        const index = startIndex + i;
        const color = CLASS_COLORS[index % CLASS_COLORS.length];

        const newClass = {
          id: name,
          name,
          color,
          index,
        };

        newClasses.push(newClass);
      }

      setClasses(newClasses);
      setNewClassName("");

      // Save to both IndexedDB and backend
      // await saveClasses(newClasses);
      await saveProjectClasses(newClasses, projectName);
      await loadClasses();
    } catch (error) {
      console.error("Failed to add classes:", error);
    }
  };

  const handleEditClass = async (oldName) => {
    const newName = editClassValue.trim();
    if (!newName) return;

    // Prevent duplicate name
    if (classes.some((cls) => cls.name === newName)) {
      console.error("Class name must be unique.");
      return;
    }

    const updatedClasses = classes.map((cls) =>
      cls.name === oldName
        ? { ...cls, name: newName, id: newName } // Update both name and id
        : cls
    );

    try {
      setClasses(updatedClasses);
      // await saveClasses(updatedClasses);
      await saveProjectClasses(updatedClasses, projectName);
      setEditingClass(null);
      setEditClassValue("");
      await loadClasses();
    } catch (error) {
      console.error("Failed to edit class:", error);
    }
  };

  const handleDeleteClass = async (nameToDelete) => {
    const updatedClasses = classes
      .filter((cls) => cls.name !== nameToDelete)
      .map((cls, idx) => ({
        ...cls,
        index: idx,
      }));

    setClasses(updatedClasses);
    // await saveClasses(updatedClasses);
    await saveProjectClasses(updatedClasses, projectName);
    await loadClasses();
  };
  // class manangement --------------------------------

  // add more images ---------------------------------------

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".webp", ".bmp"],
    },
    multiple: true,
    onDrop: (acceptedFiles) => {
      handleAddMoreImages({ target: { files: acceptedFiles } });
    },
  });
  const handleAddMoreImages = async (e) => {
    const files = Array.isArray(e) ? e : Array.from(e.target.files);
    if (files.length === 0) return;

    setUploading(true);

    try {
      const newImages = await Promise.all(
        files.map((file) => {
          return new Promise((resolve) => {
            resolve({
              name: file.name,
              data: URL.createObjectURL(file), // For immediate display
              blob: file, // The actual File object (which is a Blob)
            });
          });
        })
      );

      // await addMoreImages(newImages);
      const prevLength = images?.length || 0;
      const lastId =
        images?.length > 0 ? Math.max(...images.map((img) => img.id)) : 0;

      const res = await addImages(
        newImages.map((img, index) => ({
          id: lastId + index + 1, // Start from lastId + 1
          name: img.name,
          blob: img.blob,
        })),
        projectName
      );
      // console.log("res", res);
      // const savedImages = await getImages();
      // setImages(savedImages);
    } catch (error) {
      console.error("Failed to add images:", error);
    } finally {
      setUploading(false);
      e.target.value = ""; // Reset file input
    }
  };

  // add more images ---------------------------------------

  // -------------------download dataset-------------

  const [isDownloading, setIsDownloading] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);



  const handleDownloadDataset = async () => {
    try {
      setIsDownloading(true)
      setShowDownloadModal(true)
      setDownloadProgress("Starting...")
      const { type } = await fetchAnnotationType(projectName);
      const response = await fetch(`${NODE_SERVER_URL}/download_dataset/${projectName}?type=${type}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.ok) {
        throw new Error("Failed to download dataset")
      }

      const contentLength = Number(response.headers.get("content-length")) || null
      const fileStream = streamSaver.createWriteStream(`${projectName}_dataset.tar.gz`, {
        size: contentLength
      })

      const reader = response.body.getReader()
      const writer = fileStream.getWriter()

      let received = 0
      while (true) {
        const { done, value } = await reader.read()
        if (done) break
        await writer.write(value)
        received += value.length

        if (contentLength) {
          const percent = Math.round((received / contentLength) * 100)
          setDownloadProgress(`Downloading... ${percent}%`)
        } else {
          const mb = (received / 1024 / 1024).toFixed(1)
          setDownloadProgress(`Downloading... ~${mb} MB`)
        }
      }

      await writer.close()
      setShowDownloadModal(false)
      setIsDownloading(false)
    } catch (error) {
      console.error("Error downloading project:", error)
      setDownloadProgress("Download failed")
      setShowDownloadModal(false)
      setIsDownloading(false)
    }
  }


  // -------------------download dataset-------------

  // upload modal ---------------------------
  const [showModelUpload, setShowModelUpload] = useState(false);
  const [modelUploading, setModelUploading] = useState(false);
  const [modelUploadMessage, setModelUploadMessage] = useState("");
  const modelInputRef = useRef(null);

  // Handler for model upload
  const handleModelUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setModelUploading(true);
    setModelUploadMessage("");
    try {
      const response = await uploadModel(projectName, file, classes.map(c => c.name));
      setModelUploadMessage(`Model uploaded: ${response.status || "Success"}`);
      const loadedClasses = await loadClasses()
      setClasses(loadedClasses)
    } catch (err) {
      setModelUploadMessage(`Upload failed: ${err?.message || err}`);
    } finally {
      setModelUploading(false);
      e.target.value = "";
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-pulse text-gray-500">
          Loading project data...
        </div>
      </div>
    );
  }

  return (
    <div className="py-4 mt-14 max-w-[85rem] mx-auto">

      {/* Header Section */}
      <div className="flex flex-col justify-between  mx-4">
        {" "}
        <div className="">
          <button
            className="bg-gray-100 px-2 py-1 rounded hover:bg-blue-200 hover:text-blue-500 hover:underline"
            onClick={() => navigate(`/all-project/${userName}`)}
          >
            All Projects
          </button>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">{projectName}</h1>
            <p className="text-gray-500 mt-1">
              Dataset Length - {datasetLength}
            </p>
          </div>

          <div className="flex flex-row gap-5 justify-between items-center">
            <div className="mt-4 md:mt-0 flex items-center bg-gray-100 rounded-lg p-1">
              <button
                className={`flex items-center px-2 py-1 rounded-md transition-all ${labelOrSegment === "label"
                  ? "bg-indigo-600 text-white shadow-sm"
                  : "text-gray-700 hover:bg-gray-200"
                  }`}
                onClick={() => handleTypeChange("label")}
                disabled={loadingType}
              >
                <FiTag className="mr-2" />
                Label
                {loadingType && labelOrSegment === "label" && (
                  <span className="ml-2 inline-block h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
              </button>
              <button
                className={`flex items-center px-2 py-1 rounded-md transition-all ${labelOrSegment === "segment"
                  ? "bg-indigo-600 text-white shadow-sm"
                  : "text-gray-700 hover:bg-gray-200"
                  }`}
                onClick={() => handleTypeChange("segment")}
                disabled={loadingType}
              >
                <FiScissors className="mr-2" />
                Segment
                {loadingType && labelOrSegment === "segment" && (
                  <span className="ml-2 inline-block h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
              </button>
              <button
                className={`flex items-center px-2 py-1 rounded-md transition-all ${labelOrSegment === "ocr"
                  ? "bg-indigo-600 text-white shadow-sm"
                  : "text-gray-700 hover:bg-gray-200"
                  }`}
                onClick={() => handleTypeChange("ocr")}
                disabled={loadingType}
              >
                <FiEdit2 className="mr-2" />
                OCR
                {loadingType && labelOrSegment === "ocr" && (
                  <span className="ml-2 inline-block h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
              </button>
            </div>
            {/*<button className="mt-4 md:mt-0 ml-0 md:ml-4 flex items-center px-5 py-2.5 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-all shadow-sm hover:shadow-md">
            <MdOutlineDataSaverOn className="mr-2" />
            Save Annotaions
          </button>*/}

            <button
              className="mt-4 md:mt-0 ml-0 md:ml-4 flex items-center px-2 py-1 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all shadow-sm hover:shadow-md"
              onClick={handleDownloadDataset}
            >
              <FiDownload className="mr-2" />
              Download Dataset
            </button>
            {/* Assign Images */}
            <button
              onClick={() => setShowAssignMenu(!showAssignMenu)}
              className="mt-4 md:mt-0 ml-0 md:ml-4 flex items-center px-2 py-1 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all shadow-sm hover:shadow-md"
            >
              <FiUserPlus className="mr-2" />
              Assign Images
            </button>
            {/* Model Upload Button */}
            <button
              className="mt-4 md:mt-0 ml-0 md:ml-4 flex items-center px-2 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all shadow-sm hover:shadow-md"
              onClick={() => modelInputRef.current && modelInputRef.current.click()}
              disabled={modelUploading}
            >
              <FiUpload className="mr-2" />
              {modelUploading ? "Uploading Model..." : "Upload Model"}
            </button>
            <input
              type="file"
              accept=".pt"
              ref={modelInputRef}
              style={{ display: "none" }}
              onChange={handleModelUpload}
            />
            {modelUploadMessage && (
              <span className="ml-2 text-sm text-gray-700">{modelUploadMessage}</span>
            )}
            {/* project stats */}
            <ProjectStats setShowStatsDropdown={setShowStatsDropdown} stats={stats} showStatsDropdown={showStatsDropdown} />
          </div>
        </div>
      </div>

      {/* Assignment Dropdown */}
      {showAssignMenu && (
        <div className="absolute right-4 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-10 w-80">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h3 className="font-medium text-gray-800 text-sm">
              Assign Images From:
            </h3>
            <p className="text-sm font-semibold text-indigo-600">
              {projectName}
            </p>
            <div className="flex justify-between mt-2 text-xs">
              <div className="text-gray-500">
                <span className="font-medium">Total:</span> {stats?.totalImages}
              </div>
              <div className="text-gray-500">
                <span className="font-medium">Labeled:</span> {stats?.labeledImages}
              </div>
              <div className="text-green-600 font-medium">
                <span className="font-medium">Available:</span>{" "}
                {stats?.totalImages - stats?.labeledImages}
              </div>
            </div>
          </div>

          <div className="p-3 max-h-60 overflow-y-auto">
            {users.length === 0 ? (
              <div className="text-center py-2 text-gray-500 text-sm">
                No users available
              </div>
            ) : (
              users.map((user, idx) => (
                <div key={idx}>
                  <UserAssignmentInput
                    user={user}
                    availableImages={stats?.totalImages - stats?.labeledImages}
                    onAssign={(count) => assignImages(user.username, count)}
                  />
                  {idx < users.length - 1 && (
                    <hr className="my-2 border-gray-100" />
                  )}
                </div>
              ))
            )}
          </div>

          <div className="bg-gray-50 px-3 py-2 border-t border-gray-200 flex justify-end">
            <button
              onClick={() => setShowAssignMenu(false)}
              className="text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 px-2 py-1 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="flex flex-col gap-8">
        {/* Classes Section */}
        <div className="w-full flex flex-row justify-evenly">
          {/* Classes Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center mb-6">
              <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                <FiTag className="text-indigo-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-800">Classes</h2>
            </div>

            {/* Add New Class */}
            <div className="flex mb-6">
              <input
                type="text"
                value={newClassName}
                onChange={(e) => setNewClassName(e.target.value)}
                placeholder="New class name (comma separated for multiple)"
                className="flex-1 p-3 border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300"
                onKeyPress={(e) => e.key === "Enter" && handleAddClass()}
              />
              <button
                onClick={handleAddClass}
                className="px-4 bg-indigo-600 text-white rounded-r-lg hover:bg-indigo-700 transition flex items-center justify-center"
              >
                <FiPlus size={18} />
              </button>
            </div>

            {/* Classes List */}
            {classes.length === 0 ? (
              <div className="text-center py-6 text-gray-400">
                No classes defined yet
              </div>
            ) : (
              <ul className="space-y-1 max-h-[250px] overflow-y-auto pr-2">
                {classes.map((cls, index) => (
                  <li
                    key={cls.id}
                    className="group flex justify-between px-2 items-center border border-gray-100 rounded-lg hover:bg-gray-50 transition"
                  >
                    {editingClass === index ? (
                      <div className="flex flex-1">
                        <input
                          type="text"
                          value={editClassValue}
                          onChange={(e) => setEditClassValue(e.target.value)}
                          className="flex-1 p-2 border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300"
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleEditClass(index)
                          }
                        />
                        <button
                          onClick={() => handleEditClass(cls.id)}
                          className="px-3 bg-emerald-500 text-white hover:bg-emerald-600 transition flex items-center"
                        >
                          <FiSave size={16} />
                        </button>
                        <button
                          onClick={() => {
                            setEditingClass(null);
                            setEditClassValue("");
                          }}
                          className="px-3 bg-gray-200 text-gray-700 hover:bg-gray-300 transition flex items-center"
                        >
                          <FiX size={16} />
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="flex items-center">
                          <span
                            className="w-3 h-3 rounded-full mr-3"
                            style={{ backgroundColor: cls.color || "#6b7280" }}
                          ></span>
                          <span className="font-medium text-gray-700">
                            {cls.name}
                          </span>
                        </div>
                        <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition">
                          <button
                            onClick={() => {
                              setEditingClass(index);
                              setEditClassValue(cls.name);
                            }}
                            className="p-1.5 text-gray-500 hover:text-indigo-600 hover:bg-indigo-50 rounded transition"
                          >
                            <FiEdit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteClass(cls.id)}
                            className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded transition"
                          >
                            <FiTrash2 size={16} />
                          </button>
                        </div>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* More image uploads */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center mb-6">
              <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                <FiUpload className="text-indigo-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Add More Images
              </h2>
            </div>

            <div
              {...getRootProps()}
              className={`flex flex-col items-center justify-center py-8 border-2 border-dashed rounded-lg cursor-pointer transition-colors ${isDragActive
                ? "border-indigo-400 bg-indigo-50"
                : "border-gray-200 hover:border-indigo-300"
                }`}
            >
              <input {...getInputProps()} />

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  {uploading ? (
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-indigo-500"></div>
                  ) : (
                    <FiImage className="text-gray-400" size={24} />
                  )}
                </div>

                {isDragActive ? (
                  <p className="text-indigo-600 mb-4 text-center font-medium">
                    Drop the images here...
                  </p>
                ) : (
                  <>
                    <p className="text-gray-500 mb-4 text-center">
                      {uploading
                        ? "Uploading images..."
                        : "Drag & drop images here or click to browse"}
                    </p>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        open(); // Use the open function instead
                      }}
                      disabled={uploading}
                      className={`inline-flex items-center px-5 py-2.5 rounded-lg transition-all shadow-sm hover:shadow-md ${uploading
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-indigo-600 text-white hover:bg-indigo-700"
                        }`}
                    >
                      <FiPlus className="mr-2" />
                      {uploading ? "Uploading..." : "Browse Files"}
                    </button>
                  </>
                )}

                <div className="mt-2 text-xs text-gray-400">
                  Supports JPG, PNG, WEBP, BMP
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Images Section */}
        <ImageSection
          images={images}
          allAnnotations={allAnnotations || []}
          userName={userName}
          projectName={projectName}
          labelOrSegment={labelOrSegment}
        />
        {/* heatmap */}
        <AnnotaionHeatmap image={images[0]} allAnnotations={allAnnotations || []} />
      </div>

      {/* Download Modal */}
      {showDownloadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <div className="flex items-center justify-center mb-4">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mr-3"></div>
              <h3 className="text-lg font-semibold">Downloading Project</h3>
            </div>
            <p className="text-center text-gray-600">
              Preparing your dataset...
            </p>
            {/* Show download progress */}
            <div className="mt-4 text-center text-indigo-700 font-semibold">
              {downloadProgress}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectOverview;



const ProjectStats = ({ showStatsDropdown, setShowStatsDropdown, stats }) => {
  return (
    <div className="relative">
      <button
        className="group flex items-center px-1 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all duration-200 shadow-sm hover:shadow-md focus:ring-2 focus:ring-indigo-400 focus:outline-none"
        onClick={() => setShowStatsDropdown(!showStatsDropdown)}
      >
        <span className="">Project Stats</span>
        <FiChevronDown
          className={`ml-2 w-4 h-4 transition-transform duration-200 ${showStatsDropdown ? 'rotate-180' : ''
            }`}
        />
      </button>

      {showStatsDropdown && stats && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-100 z-50 animate-fade-in-up">
          {/* Header */}
          <div className="px-5 py-3.5 bg-gradient-to-r from-indigo-50 to-indigo-100 border-b border-indigo-100">
            <h3 className="font-semibold text-indigo-800 flex items-center">
              <FiBarChart2 className="w-5 h-5 mr-2 text-indigo-600" />
              Project Overview
            </h3>
          </div>

          {/* Stats List */}
          <ul className="divide-y divide-gray-100 max-h-96 overflow-y-auto">
            {[
              { label: "Annotation Type", value: stats.annotationType, icon: <FiTag className="text-gray-400" /> },
              { label: "Created At", value: new Date(stats.createdAt).toLocaleString(), icon: <FiCalendar className="text-gray-400" /> },
              { label: "Created By", value: stats.createdBy, icon: <FiUser className="text-gray-400" /> },
              { label: "Updated At", value: new Date(stats.updatedAt).toLocaleString(), icon: <FiRefreshCw className="text-gray-400" /> },
              { label: "Total Images", value: stats.totalImages, icon: <FiImage className="text-gray-400" /> },
              { label: "Labeled Images", value: stats.labeledImages, icon: <FiCheckCircle className="text-gray-400" /> },
              { label: "Unlabeled Images", value: stats.unlabeledImages, icon: <FiXCircle className="text-gray-400" /> },
              {
                label: "Completion",
                value: `${stats.completionPercentage}%`,
                icon: <FiPercent className="text-gray-400" />,
                extra: (
                  <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5">
                    <div
                      className="bg-gradient-to-r from-indigo-500 to-purple-500 h-1.5 rounded-full"
                      style={{ width: `${stats.completionPercentage}%` }}
                    ></div>
                  </div>
                )
              },
            ].map((item, index) => (
              <li key={index} className="px-5 py-3 hover:bg-gray-50 transition-colors duration-150">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-0.5">
                    {item.icon}
                  </div>
                  <div className="ml-3 flex-1">
                    <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {item.label}
                    </div>
                    <div className="text-sm font-semibold text-gray-800 mt-0.5">
                      {item.value}
                    </div>
                    {item.extra && item.extra}
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {/* Footer */}
          <div className="px-5 py-2.5 bg-gray-50 border-t border-gray-100 text-xs text-gray-500 flex justify-between items-center">
            <span>Last updated: {new Date().toLocaleTimeString()}</span>
            <button
              className="text-indigo-600 hover:text-indigo-800 transition-colors flex items-center"
              onClick={() => setShowStatsDropdown(false)}
            >
              <FiX className="mr-1" /> Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};





const UserAssignmentInput = ({ user, availableImages, onAssign }) => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userStats, setUserStats] = useState(null);

  const handleAssign = () => {
    const count = parseInt(inputValue);

    if (isNaN(count) || count <= 0) {
      alert("Please enter a valid positive number");
      return;
    }

    if (count > availableImages) {
      alert(`Cannot assign more than ${availableImages} images`);
      return;
    }

    onAssign(count);
    setInputValue("");
  };

  return (
    <div className="mb-3 last:mb-0">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">
          {user.username}
        </span>
        {userStats && (
          <span className="text-xs text-gray-500">
            Assigned: {userStats.totalAssigned || 0} • Labeled:{" "}
            {userStats.labeled || 0}
          </span>
        )}
        {loading && <span className="text-xs text-gray-500">Loading...</span>}
        {error && <span className="text-xs text-red-500">{error}</span>}
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={inputValue}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            setInputValue(value);
          }}
          placeholder="Enter count"
          className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
        />
        <button
          onClick={handleAssign}
          disabled={
            !inputValue ||
            parseInt(inputValue) <= 0 ||
            parseInt(inputValue) > availableImages
          }
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Assign
        </button>
      </div>
    </div>
  );
};